module.exports = __webpack_public_path__ + "assets/img/00099.e75cf9f9.png";